import { ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toastification';
import axios from '@/axios';

export default function useBasketLineAddedByComposable()
{
    const store = useStore();
    const { t } = useI18n({ useScope: 'global' });
    const toast = useToast();

    const addedBy = ref(null);
    const loadingAddedBy = ref(false);

    // ------------------------------------------------------------ METHODS

    /**
     * Fetch the username of the user who added the given basket line.
     *
     * @param {number} basketLineId
     */
    async function fetchAddedBy(basketLineId)
    {
        if(loadingAddedBy.value)
        {
            return;
        }

        loadingAddedBy.value = true;

        try
        {
            const eid = store.state.account.cEntity.id;
            const { data: user } = await axios.get(`/api/basket/${eid}/${basketLineId}/user`);
            addedBy.value = user?.username ?? null;
        }
        catch(error)
        {
            if(error.response?.status === 404)
            {
                addedBy.value = t('common.errors.http.not_found');
                return;
            }

            addedBy.value = null;
            toast.error(t('common.errors.error'));
        }
        finally
        {
            loadingAddedBy.value = false;
        }
    }


    // ------------------------------------------------------------ EXPORT

    return {
        addedBy,
        loadingAddedBy,
        fetchAddedBy,
    };
};
